import React from 'react';
import { FormField, Select } from '@cian/ui-kit';
import { type IField } from '../../types/calculator';
import { useBaseField } from '../BaseField';
import { getFieldPlaceholder } from '../../utils/getFieldPlaceholder';

export const SelectField: React.FC<IField> = props => {
  const { field, fieldState } = useBaseField(props);

  const isError = fieldState.isDirty || fieldState.invalid;

  return (
    <FormField
      label={props.label}
      errorMessage={isError ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <Select
        data-testid={field.name}
        options={props.source || []}
        value={String(field.value)}
        onChange={field.onChange}
        placeholder={getFieldPlaceholder(props.placeholder)}
        invalid={Boolean(isError && fieldState.error)}
        name={field.name}
        ref={field.ref}
        disabled={props.disabled}
        size="M"
      />
    </FormField>
  );
};

SelectField.displayName = 'SelectField';
